import { SmsGateEnum } from '@zaoblako/shared/modules/integration/enums/sms.gate.enum';
import { SmsGateEnumI18n } from '@zaoblako/shared/modules/integration/i18n/sms.gate.enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { NotificationDtoKeysEnum } from '@zaoblako/shared/modules/notification/enums/notification-dto-keys.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { entityLikeSchemaFactory } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { IntegrationCheckersEnum } from '@zaoblako/shared/modules/integration/enums/integration-checkers.enum';
import type { MainSmsAccountFindInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-find.dto';
import type { SerdeContextInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context.interface';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';

/** SMS sender create/update request body - DTO signature */
export interface SmsSenderFormInterface {
  /** SMS-gate to use */
  gate: SmsGateEnum;
  /**
   * "MainSMS" SMS-gate account credentials. Required only
   * when {@link SmsSenderFormInterface.gate} property
   * equals {@link SmsGateEnum.MAIN_SMS}.
   */
  mainSmsAccount?: MainSmsAccountFindInterface;
}

/** SMS sender create/update request body - DTO schema */
export const SmsSenderFormDto = SerdeDtoClass.create<SmsSenderFormInterface>(NotificationDtoKeysEnum.SMS_SENDER_FORM_DTO, {
  gate: {
    label: 'СМС-гейт',
    serializer: commonEnumValidator(SmsGateEnum, SmsGateEnumI18n),
  },
  mainSmsAccount: {
    optional: (context: SerdeContextInterface<SerdeContextDataInterface, SmsSenderFormInterface>) => context?.value?.gate !== SmsGateEnum.MAIN_SMS,
    label: 'Аккаунт "MainSMS"',
    checkers: [IntegrationCheckersEnum.MAIN_SMS_ACCOUNT_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchemaFactory<SerdeContextDataInterface, SmsSenderFormInterface>(context => context?.value?.gate === SmsGateEnum.MAIN_SMS),
  },
});
